<script lang="ts">
    import type {PaginationStruct} from '$lib/utils';

    export let pagination: PaginationStruct;
</script>

{#if pagination && pagination.list && pagination.list.length > 1}
    <div class="flex items-center justify-center my-6 font-bold select-none">
        {#if pagination.prev && pagination.prev.type === 'number'}
            <a
                class="text-black fill-black hover:text-green hover:fill-green !no-underline px-3 transition-colors flex gap-x-2 items-center"
                href={pagination.prev.url}
            >
                <svg class="w-3" viewBox="0 0 405.456 405.456" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M341.31 74.135c-.078-4.985-2.163-9.911-5.688-13.438l-55-55C277.023 2.096 271.963 0 266.872 0s-10.151 2.096-13.75 5.697L69.841 188.978c-3.601 3.599-5.697 8.659-5.697 13.75s2.096 10.151 5.697 13.75l183.281 183.281c3.599 3.601 8.659 5.697 13.75 5.697s10.151-2.096 13.75-5.697l55-55c3.591-3.598 5.681-8.651 5.681-13.734s-2.09-10.136-5.681-13.734L221.06 202.728 335.622 88.166c3.665-3.667 5.765-8.848 5.688-14.031z"
                    />
                </svg>Пред
            </a>
        {/if}

        {#each pagination.list as p}
            {#if p.type === 'ellipsis'}
                <span class="hidden px-3 sm:block text-black-500">• • •</span>
            {:else if p.active}
                <span class="px-3 text-black-500">{p.page}</span>
            {:else}
                <a class="hidden sm:block text-black hover:text-green !no-underline px-3 transition-colors" href={p.url}>{p.page}</a>
            {/if}
        {/each}

        {#if pagination.next && pagination.next.type === 'number'}
            <a
                class="text-black fill-black hover:text-green hover:fill-green !no-underline px-3 transition-colors flex gap-x-2 items-center"
                href={pagination.next.url}
            >
                След<svg class="w-3" viewBox="0 0 405.457 405.457" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M64.147 331.322c.078 4.985 2.163 9.911 5.688 13.438l55 55c3.599 3.601 8.659 5.697 13.75 5.697 5.091 0 10.151-2.096 13.75-5.697l183.281-183.282c3.601-3.599 5.697-8.659 5.697-13.75s-2.096-10.151-5.697-13.75L152.335 5.697C148.736 2.096 143.676 0 138.585 0c-5.091 0-10.151 2.096-13.75 5.697l-55 55c-3.591 3.598-5.681 8.651-5.681 13.734s2.09 10.136 5.681 13.734l114.562 114.563L69.835 317.291c-3.664 3.667-5.765 8.848-5.688 14.031z"
                    />
                </svg>
            </a>
        {/if}
    </div>
{/if}
